<template>
  <div class="component-clicksign">
    <h4 class="text-semibold mb-5">Clicksign</h4>
    <snow-data-table-header
      class="mb-6"
      @add="modal = true"
      @searching="searching"
      :datePicker="false"
      :filters="false"
    />
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>
    <div v-else>
      <snow-data-table :data="integrationList" :columns="clicksignColumns">
        <template #eventos="{ value }">
          <snow-table-events :events="value" />
        </template>
        <template #url="{ item }">
          <div class="d-flex">
            <snow-button variant="borderless" size="sm" @click="copyUrl(item)">
              <i class="ph ph-link" />
            </snow-button>
            <snow-button variant="borderless" size="sm" @click="openUrl(item)">
              <i class="ph ph-arrow-square-out" />
            </snow-button>
          </div>
        </template>
        <template #no-content-actions>
          <snow-button
            icon="ph ph-plus"
            text="Adicionar integração"
            @click="modal = true"
          />
        </template>
      </snow-data-table>
    </div>
    <div class="d-flex justify-content-end mt-4">
      <snow-paginator
        v-model="page"
        :pagination="pagination"
        @change-page="dispatch"
      />
    </div>
    <clicksign-modal
      v-model="modal"
      :integrationToEdit="integrationToEdit"
      @clear-edit="integrationToEdit = null"
      @update-list="dispatch"
      @loading="loading = true"
    />
  </div>
</template>
<script>
import ClicksignModal from "@/components/tools/modals/Clicksign.vue";
import { clearObject } from "@/functions/helpers";
import IntegrationsMixin from "@/mixins/integration.js";
import { mapState } from "vuex";
export default {
  components: {
    ClicksignModal
  },
  mixins: [IntegrationsMixin],
  data() {
    return {
      loading: false,
      integrationToEdit: null,
      integration: "clicksign",
      modal: false
    };
  },
  mounted() {
    this.$store.commit("integration/setIntegration", this.integration);
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("integration", ["integrationList", "pagination"]),
    clicksignColumns() {
      return [
        {
          name: "Produto",
          field: "product_name"
        },
        {
          name: "Descrição",
          field: "description",
          transform: v => this.formatLongText(v)
        },
        {
          name: "Token",
          field: "token"
        },
        {
          name: "Status",
          field: "status",
          transform: v => (v ? "Ativo" : "Inativo"),
          color: v => (v ? "green" : "negative"),
          type: "tag"
        },
        {
          type: "menu",
          options: this.getActions
        }
      ];
    }
  },
  methods: {
    getActions(item) {
      return [
        {
          label: item.status ? "Desativar" : "Ativar",
          click: this.changeStatus
        },
        {
          label: "Editar",
          click: this.edit
        },
        {
          label: "Excluir",
          class: "text-danger",
          variant: "danger",
          dialog: {
            text: "Deseja mesmo excluir esta integração?",
            icon: "ph ph-trash",
            buttonText: "Sim, excluir",
            action: this.submitDelete,
            secondaryButtonText: "Não, cancelar"
          }
        }
      ];
    },
    refresh() {
      this.$refs.paginator.reset();
    },
    dispatch(offset = 0) {
      let params = { offset };

      if (this.search) {
        params = { search: this.search };
      }

      this.loading = true;
      this.$store
        .dispatch("integration/getIntegration", params)
        .catch(error => {
          this.$message.error("Não foi possível carregar as integrações");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeStatus(item) {
      let data = { ...item, status: !item.status };
      this.$store
        .dispatch("integration/putIntegration", clearObject(data))
        .then(() => {
          this.$message.success(
            `Integração ${data.status ? "ativada" : "desativada"}`
          );
          this.dispatch();
        })
        .catch(error => {
          this.$message.error(
            "Não foi possível alterar o status da integração"
          );
        });
    }
  }
};
</script>
